var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    _vm._b(
      {
        staticClass: "modal-content",
        attrs: {
          title: `${
            _vm.modelType === "edit"
              ? "编辑"
              : _vm.modelType === "view"
              ? "查看"
              : "添加"
          }家访记录`,
          width: 900,
          visible: _vm.visible,
          "ok-text": "保存",
          destroyOnClose: "",
        },
        on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
      },
      "a-modal",
      _vm.extraProps,
      false
    ),
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: _vm.labelCol,
              wrapperCol: _vm.wrapperCol,
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _c(
              "a-row",
              {
                staticStyle: {
                  "padding-left": "14px",
                  "padding-right": "26px",
                },
                attrs: { gutter: 0 },
              },
              [
                _c(
                  "a-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: "选择年级",
                          prop: "gradeId",
                          labelCol: { ..._vm.itemLabelCol },
                          wrapperCol: _vm.itemWrapperCol,
                        },
                      },
                      [
                        _c("j-dict-select-tag", {
                          attrs: {
                            placeholder: "请选择年级",
                            disabled: ["edit", "view", "append"].includes(
                              _vm.modelType
                            ),
                            dictCode:
                              "school_grade,grade_name,id,0=delete_flag order by sort_order",
                            allowClear: "",
                          },
                          on: {
                            select: () => {
                              _vm.$set(_vm.form, "classId", undefined)
                              _vm.$set(_vm.form, "studentId", undefined)
                            },
                          },
                          model: {
                            value: _vm.form.gradeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "gradeId", $$v)
                            },
                            expression: "form.gradeId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: "选择班级",
                          prop: "classId",
                          labelCol: _vm.itemLabelCol,
                          wrapperCol: _vm.itemWrapperCol,
                        },
                      },
                      [
                        _c("j-dict-select-tag", {
                          attrs: {
                            placeholder: "请选择班级",
                            dictCode:
                              "school_class,name,id,grade_id=" +
                              (!_vm.form.gradeId ? -1 : _vm.form.gradeId),
                            disabled:
                              !_vm.form.gradeId ||
                              ["edit", "view", "append"].includes(
                                _vm.modelType
                              ),
                            isShowEmpty: false,
                          },
                          on: {
                            select: function ($event) {
                              return _vm.$set(_vm.form, "studentId", undefined)
                            },
                          },
                          model: {
                            value: _vm.form.classId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "classId", $$v)
                            },
                            expression: "form.classId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: "选择学生",
                          prop: "studentId",
                          labelCol: _vm.itemLabelCol,
                          wrapperCol: _vm.itemWrapperCol,
                        },
                      },
                      [
                        _c("j-dict-select-tag", {
                          staticClass: "search-space",
                          attrs: {
                            placeholder: "请选择学生",
                            isShowSearch: true,
                            disabled:
                              !_vm.form.classId ||
                              ["edit", "view", "append"].includes(
                                _vm.modelType
                              ),
                            dictCode:
                              "student_info,name,id,class_id=" +
                              (!_vm.form.classId ? -1 : _vm.form.classId),
                            async: true,
                          },
                          model: {
                            value: _vm.form.studentId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "studentId", $$v)
                            },
                            expression: "form.studentId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "家访时间", prop: "visitTime" } },
              [
                _c("a-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    showTime: "",
                    placeholder: "请选择日期",
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.visitTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "visitTime", $$v)
                    },
                    expression: "form.visitTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "家访目的", prop: "visitIntent" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择家访目的",
                    extraOptions: _vm.menuMaps.homeVisitPurpose,
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.visitIntent,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "visitIntent", $$v)
                    },
                    expression: "form.visitIntent",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "家庭情况", prop: "familySituation" } },
              [
                _c(
                  "a-popover",
                  {
                    attrs: {
                      trigger: "click",
                      placement: "bottomLeft",
                      overlayClassName: "special-popover",
                      getPopupContainer: (trigger) => trigger.parentNode,
                    },
                    model: {
                      value: _vm.familyPopoverVisible,
                      callback: function ($$v) {
                        _vm.familyPopoverVisible = $$v
                      },
                      expression: "familyPopoverVisible",
                    },
                  },
                  [
                    _c("template", { slot: "content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "special-dropdown-content",
                          style: { width: _vm.triggerWidth + "px" },
                        },
                        [
                          _c("div", { staticClass: "section" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("家庭结构"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tag-group" },
                              _vm._l(
                                _vm.menuMaps.homeVisitStructure,
                                function (item) {
                                  return _c(
                                    "a-checkable-tag",
                                    {
                                      key: item.value,
                                      attrs: {
                                        checked:
                                          _vm.tempFamily.structure.includes(
                                            item.value
                                          ),
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleTagChange(
                                            "structure",
                                            item.value,
                                            checked
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "section" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("家庭经济情况"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tag-group" },
                              _vm._l(
                                _vm.menuMaps.homeVisitFinancialSituation,
                                function (item) {
                                  return _c(
                                    "a-checkable-tag",
                                    {
                                      key: item.value,
                                      attrs: {
                                        checked:
                                          _vm.tempFamily.financialSituation ===
                                          item.value,
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleTagChange(
                                            "financialSituation",
                                            item.value,
                                            checked
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "section" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("家庭氛围"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tag-group" },
                              _vm._l(
                                _vm.menuMaps.homeVisitAtmosphere,
                                function (item) {
                                  return _c(
                                    "a-checkable-tag",
                                    {
                                      key: item.value,
                                      attrs: {
                                        checked:
                                          _vm.tempFamily.atmosphere ===
                                          item.value,
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleTagChange(
                                            "atmosphere",
                                            item.value,
                                            checked
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "section" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("亲子关系"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tag-group" },
                              _vm._l(
                                _vm.menuMaps.homeVisitChildRelationship,
                                function (item) {
                                  return _c(
                                    "a-checkable-tag",
                                    {
                                      key: item.value,
                                      attrs: {
                                        checked:
                                          _vm.tempFamily.childRelationship ===
                                          item.value,
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleTagChange(
                                            "childRelationship",
                                            item.value,
                                            checked
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "section" },
                            [
                              _c("div", { staticClass: "section-title" }, [
                                _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("学生健康情况"),
                              ]),
                              _c("a-textarea", {
                                attrs: {
                                  placeholder:
                                    "请输入学生健康情况(如过敏、遗传病史、先天性疾病等)",
                                  "auto-size": { minRows: 3, maxRows: 5 },
                                  "max-length": 200,
                                },
                                model: {
                                  value: _vm.tempFamily.healthCondition,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.tempFamily,
                                      "healthCondition",
                                      $$v
                                    )
                                  },
                                  expression: "tempFamily.healthCondition",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "dropdown-footer" },
                            [
                              _c(
                                "a-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.familyPopoverVisible = false
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.confirmFamily },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "custom-select-trigger",
                        class: {
                          disabled: _vm.isView,
                          active: _vm.familyPopoverVisible,
                        },
                      },
                      [
                        _vm.familySituationText
                          ? _c("span", { staticClass: "trigger-text" }, [
                              _vm._v(_vm._s(_vm.familySituationText)),
                            ])
                          : _c("span", { staticClass: "trigger-placeholder" }, [
                              _vm._v("请选择家庭情况"),
                            ]),
                        _c("a-icon", {
                          staticClass: "trigger-icon",
                          attrs: { type: "down" },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "学业情况", prop: "academicSituation" } },
              [
                _c(
                  "a-popover",
                  {
                    attrs: {
                      trigger: "click",
                      placement: "bottomLeft",
                      overlayClassName: "special-popover",
                      getPopupContainer: (trigger) => trigger.parentNode,
                    },
                    model: {
                      value: _vm.academicPopoverVisible,
                      callback: function ($$v) {
                        _vm.academicPopoverVisible = $$v
                      },
                      expression: "academicPopoverVisible",
                    },
                  },
                  [
                    _c("template", { slot: "content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "special-dropdown-content",
                          style: { width: _vm.triggerWidth + "px" },
                        },
                        [
                          _c("div", { staticClass: "section" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("成绩情况"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tag-group" },
                              _vm._l(
                                _vm.menuMaps.homeVisitPerformanceStatus,
                                function (item) {
                                  return _c(
                                    "a-checkable-tag",
                                    {
                                      key: item.value,
                                      attrs: {
                                        checked:
                                          _vm.tempAcademic.performanceStatus.includes(
                                            item.value
                                          ),
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleAcademicTagChange(
                                            "performanceStatus",
                                            item.value,
                                            checked
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "section" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("上课情况"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tag-group" },
                              _vm._l(
                                _vm.menuMaps.homeVisitClassAttendance,
                                function (item) {
                                  return _c(
                                    "a-checkable-tag",
                                    {
                                      key: item.value,
                                      attrs: {
                                        checked:
                                          _vm.tempAcademic.classAttendance.includes(
                                            item.value
                                          ),
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleAcademicTagChange(
                                            "classAttendance",
                                            item.value,
                                            checked
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "section" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("作业完成情况"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tag-group" },
                              _vm._l(
                                _vm.menuMaps.homeVisitHomeworkCompletionStatus,
                                function (item) {
                                  return _c(
                                    "a-checkable-tag",
                                    {
                                      key: item.value,
                                      attrs: {
                                        checked:
                                          _vm.tempAcademic
                                            .homeworkCompletionStatus ===
                                          item.value,
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleAcademicTagChange(
                                            "homeworkCompletionStatus",
                                            item.value,
                                            checked
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "dropdown-footer" },
                            [
                              _c(
                                "a-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.academicPopoverVisible = false
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.confirmAcademic },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "custom-select-trigger",
                        class: {
                          disabled: _vm.isView,
                          active: _vm.academicPopoverVisible,
                        },
                      },
                      [
                        _vm.academicSituationText
                          ? _c("span", { staticClass: "trigger-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.academicSituationText) +
                                  "\n            "
                              ),
                            ])
                          : _c("span", { staticClass: "trigger-placeholder" }, [
                              _vm._v("请选择学业情况"),
                            ]),
                        _c("a-icon", {
                          staticClass: "trigger-icon",
                          attrs: { type: "down" },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "家长配合度", prop: "parentalCooperation" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择家长配合度",
                    disabled: _vm.isView,
                    extraOptions: _vm.menuMaps.parentalCooperation,
                  },
                  model: {
                    value: _vm.form.parentalCooperation,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "parentalCooperation", $$v)
                    },
                    expression: "form.parentalCooperation",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "应对措施", prop: "responseMeasures" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择应对措施",
                    mode: "multiple",
                    extraOptions: _vm.menuMaps.countermeasure,
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.responseMeasures,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "responseMeasures", $$v)
                    },
                    expression: "form.responseMeasures",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "家访照片" } },
              [
                !_vm.isView
                  ? _c(
                      "a-upload",
                      {
                        attrs: {
                          name: "file",
                          multiple: true,
                          headers: _vm.tokenHeader,
                          action: _vm.importExcelUrl,
                          "file-list": _vm.defaultFileList,
                        },
                        on: {
                          change: _vm.uploadFile,
                          preview: _vm.handlePreview,
                        },
                      },
                      [
                        _vm.defaultFileList.length < 3
                          ? _c("a-button", { attrs: { icon: "import" } }, [
                              _vm._v("上传文件"),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm.isView && _vm.form.fileUrl
                  ? _c(
                      "div",
                      { staticClass: "view-file-list" },
                      _vm._l(
                        (_vm.form.fileUrl || "").split(",").filter(Boolean),
                        function (url, index) {
                          return _c(
                            "span",
                            {
                              key: index,
                              staticClass: "view-file-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleFilePreview(url)
                                },
                              },
                            },
                            [
                              _c("a-icon", { attrs: { type: "paper-clip" } }),
                              _vm._v(
                                "\n            附件" +
                                  _vm._s(index + 1) +
                                  "\n          "
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    )
                  : _c("span", [_vm._v("无")]),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "综合评价", prop: "comprehensiveEvaluation" } },
              [
                _c("a-textarea", {
                  attrs: {
                    placeholder: "请输入具体情况说明",
                    "auto-size": { minRows: 4, maxRows: 8 },
                    disabled: _vm.isView,
                    "max-length": 200,
                  },
                  model: {
                    value: _vm.form.comprehensiveEvaluation,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "comprehensiveEvaluation", $$v)
                    },
                    expression: "form.comprehensiveEvaluation",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }